import { render } from "./NumberControlRenderer.vue?vue&type=template&id=b8508972&scoped=true&ts=true"
import script from "./NumberControlRenderer.vue?vue&type=script&lang=ts"
export * from "./NumberControlRenderer.vue?vue&type=script&lang=ts"

import "./NumberControlRenderer.vue?vue&type=style&index=0&id=b8508972&lang=scss"
import "./NumberControlRenderer.vue?vue&type=style&index=1&id=b8508972&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8508972"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon,QTooltip,QField});
